import { SelectionInfo } from 'dragonmouse-shared/devigner';
import { Frame, TransformVisualEdit } from 'dragonmouse-shared/interfaces';
import NumberInput from 'components/Widget/Input/NumberInput';
import { findVisualEditEntry, pushEditToIframe, saveEditToFrame } from 'visualEdits';
import { trackVisualEditAction } from 'analytics';
import Field from '../Field';
import * as S from './styles';

interface OffsetControlProps {
	frame: Frame;
	selectionInfo: SelectionInfo;
}

const OffsetControl = ({ frame, selectionInfo }: OffsetControlProps) => {
	const elementId = selectionInfo.dataset?.mcElementId ?? selectionInfo.element.id;

	// Read current offset directly from frame entries — no local useState.
	// When the iframe-side nudge fires, redux updates entries, this re-renders
	// with the new value automatically. No staleness.
	const entry = findVisualEditEntry(frame, frame.siteId ?? '');
	const existing = entry?.visualEdits.find(
		(e): e is TransformVisualEdit => e.kind === 'transform' && e.elementId === elementId
	);
	const x = existing?.transform.x ?? 0;
	const y = existing?.transform.y ?? 0;

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------

	const commit = async (newX: number, newY: number) => {
		if (!frame.siteId) return;
		const edit: TransformVisualEdit = {
			kind: 'transform',
			elementId,
			transform: { x: newX, y: newY },
		};
		trackVisualEditAction('commit_offset_edit');
		await saveEditToFrame(
			frame.id,
			edit,
			(e) => e.kind === 'transform' && e.elementId === elementId,
			frame.siteId
		);
		pushEditToIframe(frame.id, edit);
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<Field label="Offset">
			<S.Row>
				<NumberInput
					label="X"
					value={x}
					onChange={(v) => void commit(v, y)}
					min={-2000}
					max={2000}
				/>
				<NumberInput
					label="Y"
					value={y}
					onChange={(v) => void commit(x, v)}
					min={-2000}
					max={2000}
				/>
			</S.Row>
			<S.Hint>↑↓←→ to nudge</S.Hint>
		</Field>
	);
};

export default OffsetControl;
